import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cAttrConfig: null,
  cAttrFilters: null,
  attrLoading: true,
};

export const cloneSlice = createSlice({
  name: "clone.slice",
  reducerPath: "clone",
  initialState,
  reducers: {
    setCAttrConfig: (state, action) => {
      state.cAttrConfig = action.payload;
    },
    setCAttrFilters: (state, action) => {
      state.cAttrFilters = action.payload;
    },
    setAttrLoading: (state, action) => {
      state.attrLoading = action.payload;
    },
    resetFilters: (state, action) => {
      const { attrObj, newSearchValues } = action.payload;

      const startIndex = attrObj._id + 1;
      if (attrObj.child && state.cAttrConfig?.attributes?.configs) {
        const newConfigs = { ...state.cAttrConfig };
        const configs = newConfigs.attributes.configs;
        for (let i = startIndex; i < configs.length; i++) {
          configs[i].values = null;
          delete newSearchValues[configs[i].name];
        }
        state.cAttrFilters = configs.map((obj, index) => ({
          ...obj,
          _id: index,
          disabled: !obj.values,
          values: !obj.values
            ? []
            : obj.values.map((item, index) => ({
                id: index,
                label: item,
                value: item,
              })),
        }));
        state.attrLoading = false;
        state.cAttrConfig = newConfigs;
      }
    },
  },
});

export const { setAttrLoading, setCAttrConfig, setCAttrFilters, resetFilters } =
  cloneSlice.actions;
